"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthCodeRedirectHandler = exports.exchangeDpopToken = void 0;
const tsyringe_1 = require("tsyringe");
const oidc_client_ext_1 = require("@inrupt/oidc-client-ext");
const fetchFactory_1 = require("../../../authenticatedFetch/fetchFactory");
async function exchangeDpopToken(sessionId, issuer, issuerFetcher, clientRegistrar, code, codeVerifier, redirectUrl) {
    const issuerConfig = await issuerFetcher.fetchConfig(issuer);
    const client = await clientRegistrar.getClient({ sessionId }, issuerConfig);
    return oidc_client_ext_1.getDpopToken(issuerConfig, client, {
        grantType: "authorization_code",
        code,
        codeVerifier,
        redirectUri: redirectUrl,
    });
}
exports.exchangeDpopToken = exchangeDpopToken;
let AuthCodeRedirectHandler = class AuthCodeRedirectHandler {
    constructor(storageUtility, sessionInfoManager, issuerConfigFetcher, clientRegistrar) {
        this.storageUtility = storageUtility;
        this.sessionInfoManager = sessionInfoManager;
        this.issuerConfigFetcher = issuerConfigFetcher;
        this.clientRegistrar = clientRegistrar;
    }
    async canHandle(redirectUrl) {
        try {
            const myUrl = new URL(redirectUrl);
            return (myUrl.searchParams.get("code") !== null &&
                myUrl.searchParams.get("state") !== null);
        }
        catch (e) {
            throw new Error(`[${redirectUrl}] is not a valid URL, and cannot be used as a redirect URL: ${e.toString()}`);
        }
    }
    async handle(redirectUrl) {
        if (!(await this.canHandle(redirectUrl))) {
            throw new Error(`AuthCodeRedirectHandler cannot handle [${redirectUrl}]: it is missing one of [code, state].`);
        }
        const url = new URL(redirectUrl);
        const oauthState = url.searchParams.get("state");
        const storedSessionId = (await this.storageUtility.getForUser(oauthState, "sessionId", {
            errorIfNull: true,
        }));
        const isDpop = (await this.storageUtility.getForUser(storedSessionId, "dpop")) ===
            "true";
        let tokens;
        let authFetch;
        if (isDpop) {
            const issuer = (await this.storageUtility.getForUser(storedSessionId, "issuer", { errorIfNull: true }));
            const codeVerifier = (await this.storageUtility.getForUser(storedSessionId, "codeVerifier", { errorIfNull: true }));
            const storedRedirectIri = (await this.storageUtility.getForUser(storedSessionId, "redirectUri", { errorIfNull: true }));
            tokens = await exchangeDpopToken(storedSessionId, issuer, this.issuerConfigFetcher, this.clientRegistrar, url.searchParams.get("code"), codeVerifier, storedRedirectIri);
            authFetch = await fetchFactory_1.buildDpopFetch(tokens.accessToken, tokens.refreshToken, tokens.dpopJwk);
        }
        else {
            tokens = await oidc_client_ext_1.getBearerToken(url.toString());
            authFetch = fetchFactory_1.buildBearerFetch(tokens.accessToken, tokens.refreshToken);
        }
        await this.storageUtility.setForUser(storedSessionId, {
            idToken: tokens.idToken,
            refreshToken: "<Refresh token that *is* coming back in the redirect URL is not yet being parsed and provided by oidc-client-js in it's response object>",
            webId: tokens.webId,
            isLoggedIn: "true",
        }, { secure: true });
        const sessionInfo = await this.sessionInfoManager.get(storedSessionId);
        if (!sessionInfo) {
            throw new Error(`Could not retrieve session: [${storedSessionId}].`);
        }
        return Object.assign(sessionInfo, {
            fetch: authFetch,
        });
    }
};
AuthCodeRedirectHandler = __decorate([
    tsyringe_1.injectable(),
    __param(0, tsyringe_1.inject("storageUtility")),
    __param(1, tsyringe_1.inject("sessionInfoManager")),
    __param(2, tsyringe_1.inject("issuerConfigFetcher")),
    __param(3, tsyringe_1.inject("clientRegistrar")),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], AuthCodeRedirectHandler);
exports.AuthCodeRedirectHandler = AuthCodeRedirectHandler;
//# sourceMappingURL=AuthCodeRedirectHandler.js.map